import * as React from 'react';
import { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker as Picker } from '@mui/x-date-pickers/TimePicker';

interface PickerProps {
  label: string;
  handleChange: (value: Dayjs | null) => void;
  value: Dayjs | null;
}

const TimePicker: React.FC<PickerProps> = ({ label, handleChange, value }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DemoContainer components={['TimePicker']}>
      <Picker
        label={label}
        value={value}
        onChange={(newValue) => handleChange(newValue)}
      />
    </DemoContainer>
  </LocalizationProvider>
);

export default TimePicker;
